let App = window.App;

class SplitText{
    constructor( el, options = {} ){
        this.el = el;
        this.$el = $( el );

        this.buildWords( this.$el );
        this.wrapLines();

        App.$window.on( 'resize', $.proxy( this.rewrapLines, this ) );
    }

    buildWords( $el ){
        $el.contents().each( ( _, el ) => {
            if( el.nodeType == 3 ){
                if( $.trim( el.textContent ) ){
                    let $el = $( el );
                    $el.replaceWith( el.textContent.replace( /(\S+)(\s)?/g, "<span class='word'>$1$2</span>" ) );
                }
            }else{
                switch( el.tagName.toLowerCase() ){
                    case 'svg':
                    case 'br':
                        break;
                    default:
                        this.buildWords( $( el ) );
                }
            }
        } );
    }

    rewrapLines(){
        this.unwrapLines();
        this.wrapLines();
    }

    wrapLines(){
        let $words = this.$el.children( '.word' );

        let lines = [], last_offset = null;

        $words.each( ( index, word ) => {
            let $word = $( word ),
                word_offset = $word.offset().top;

            if( word_offset !== last_offset ){
                last_offset = word_offset;
                lines.push( [] );
            }

            lines[ lines.length - 1 ].push( word );
        } );

        for( let line of lines ){
            let $line = $( line );
            $line.wrapAll( '<span class="line">' );
        }

        this.$el.addClass( 'split-text' );
    }

    unwrapLines(){
        this.$el.removeClass( 'split-text' ).children( '.line' ).each( ( index, line ) => {
            let $line = $( line );
            $line.contents().insertBefore( $line );
            $line.remove();
        } );
    }
}

export default SplitText;



// WEBPACK FOOTER //
// ./resources/js/modules/split-text.js